// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import logOut01Icon from "@/assets/icons/log-out-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type LogOut01IconProps = Omit<IconProps, "name">;

export function LogOut01Icon(props: LogOut01IconProps): React.ReactNode {
  return <Icon name={logOut01Icon} {...props} />;
}
